import React, { Component } from 'react';
import {
    Grid,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Tooltip,
    Zoom
} from "@material-ui/core";
import NumberFormat from "react-number-format";
import moment from 'moment'
import { withTranslation } from 'react-i18next';

class AccountSummaryTab extends Component {

    render() {
        let { accountSummaries, selectedInventory, selectedClient, selectedFrom, selectedTo, selectedRadioButton, history } = this.props

        let accountSummariesList;
        let recordsNotFound;
        if (accountSummaries && accountSummaries.length > 0) {
            accountSummariesList = accountSummaries.map((accountSummaries, index) => {
                return <TableRow key={index}>
                    <TableCell>
                        <Tooltip interactive disableFocusListener disableTouchListener transitioncomponent={Zoom} arrow title={<div style={{ fontSize: '14px', maxWidth: '200px' }} >
                            <p><b>{this.props.t("description")}:</b> {accountSummaries.account && accountSummaries.account.description}</p>
                        </div>}>
                            <span style={{ cursor: 'pointer', color: '#094b79', textDecoration: 'underline dotted' }} onClick={() => history.push({
                                pathname: '/assets',
                                state: {
                                    selectedInventory: selectedInventory,
                                    selectedClient: selectedClient,
                                    selectedAccount: accountSummaries.account,
                                    selectedFrom: moment(selectedFrom).format("DD-MM-YYYY"),
                                    selectedTo: moment(selectedTo).format("DD-MM-YYYY"),
                                    selectedRadioButton: selectedRadioButton
                                }
                            })}>{accountSummaries.account && accountSummaries.account.account}</span>
                        </Tooltip>
                    </TableCell>
                    <TableCell>
                        <Tooltip interactive disableFocusListener disableTouchListener transitioncomponent={Zoom} arrow title={<div style={{ fontSize: '14px', maxWidth: '200px' }} >
                            <p><b>{this.props.t("description")}:</b> {accountSummaries.contraAccount && accountSummaries.contraAccount.description}</p>
                        </div>}>
                            <span style={{ cursor: 'pointer', color: '#094b79' }}>{accountSummaries.contraAccount.account}</span>
                        </Tooltip>
                    </TableCell>
                    <TableCell className="custom-table-cell-numbers"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={accountSummaries.previousDepreciation} /> </TableCell>
                    <TableCell className="custom-table-cell-numbers"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={accountSummaries.currentDepreciation} /></TableCell>
                    <TableCell className="custom-table-cell-numbers"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={accountSummaries.remainingDepreciation} /></TableCell>
                    <TableCell className="custom-table-cell-numbers"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={accountSummaries.purchaseAmount} /></TableCell>
                    <TableCell className="custom-table-cell-numbers"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={accountSummaries.residualValue} /></TableCell>
                </TableRow>
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return (
            <Grid container direction="row" spacing={2}>
                <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container direction="row" spacing={2}>
                        <Grid item container>
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table" size="small" style={{ tableLayout: 'fixed' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell component="th" scope="row" width="15%">{this.props.t("account")}</TableCell>
                                            <TableCell component="th" scope="row" width="15%">{this.props.t("contra_account")}</TableCell>
                                            <TableCell component="th" scope="row" align="right" width="15%">{this.props.t("previous_depreciation")}</TableCell>
                                            <TableCell component="th" scope="row" align="right" width="15%">{this.props.t("amount_time_period")}</TableCell>
                                            <TableCell component="th" scope="row" align="right" width="15%">{this.props.t("amount_after_period")}</TableCell>
                                            <TableCell component="th" scope="row" align="right" width="15%">{this.props.t("purchase_amount")}</TableCell>
                                            <TableCell component="th" scope="row" align="right" width="10%">{this.props.t("residual_value")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {accountSummariesList}
                                        {accountSummaries.length > 0 && <TableRow style={{ borderTop: '2px solid #000' }}>
                                            <TableCell className="custom-table-cell">{this.props.t("sum")}</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell className="custom-table-cell-1"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={this.props.previousDepreciation} /></TableCell>
                                            <TableCell className="custom-table-cell-1"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={this.props.currentDepreciation} /></TableCell>
                                            <TableCell className="custom-table-cell-1"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={this.props.remainingDepreciation} /></TableCell>
                                            <TableCell className="custom-table-cell-1"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={this.props.purchaseAmount} /></TableCell>
                                            <TableCell className="custom-table-cell-1"><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={this.props.residualValue} /></TableCell>
                                        </TableRow>}
                                        {recordsNotFound}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withTranslation()(AccountSummaryTab);
